import { render, staticRenderFns } from "./unknownRecords.vue?vue&type=template&id=ab6fb0d8&scoped=true"
import script from "./unknownRecords.vue?vue&type=script&lang=js"
export * from "./unknownRecords.vue?vue&type=script&lang=js"
import style0 from "./unknownRecords.vue?vue&type=style&index=0&id=ab6fb0d8&prod&lang=scss&scoped=true"
import style1 from "./unknownRecords.vue?vue&type=style&index=1&id=ab6fb0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6fb0d8",
  null
  
)

export default component.exports